/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Due_DateInputs */

const en_explorer_info_property_due_date = /** @type {(inputs: Explorer_Info_Property_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Date`)
};

const fr_explorer_info_property_due_date = /** @type {(inputs: Explorer_Info_Property_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Date`)
};

const de_explorer_info_property_due_date = /** @type {(inputs: Explorer_Info_Property_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Date`)
};

const it_explorer_info_property_due_date = /** @type {(inputs: Explorer_Info_Property_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Date`)
};

const ru_explorer_info_property_due_date = /** @type {(inputs: Explorer_Info_Property_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Date`)
};

const es_explorer_info_property_due_date = /** @type {(inputs: Explorer_Info_Property_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Date`)
};

const zh_cn2_explorer_info_property_due_date = /** @type {(inputs: Explorer_Info_Property_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Date`)
};

const ja_explorer_info_property_due_date = /** @type {(inputs: Explorer_Info_Property_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Date`)
};

const hi_explorer_info_property_due_date = /** @type {(inputs: Explorer_Info_Property_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Date`)
};

const pt_pt2_explorer_info_property_due_date = /** @type {(inputs: Explorer_Info_Property_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Date`)
};

/**
* | output |
* | --- |
* | "Due Date" |
*
* @param {Explorer_Info_Property_Due_DateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_due_date = /** @type {((inputs?: Explorer_Info_Property_Due_DateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Due_DateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_due_date(inputs)
	if (locale === "de") return de_explorer_info_property_due_date(inputs)
	if (locale === "it") return it_explorer_info_property_due_date(inputs)
	if (locale === "ru") return ru_explorer_info_property_due_date(inputs)
	if (locale === "es") return es_explorer_info_property_due_date(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_due_date(inputs)
	if (locale === "ja") return ja_explorer_info_property_due_date(inputs)
	if (locale === "hi") return hi_explorer_info_property_due_date(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_due_date(inputs)
	return en_explorer_info_property_due_date(inputs)
});